<template>
    <div class="card">
        <div class="card-header header-elements-inline bg-white py-2">
            <h5 class="card-title">
                <i v-if="loading" class="icon-spinner2 spinner mr-1"></i>
                <span v-else-if="todos.length > 0" class="badge badge-danger badge-pill mr-1">{{ todos.length }}</span>
                <span v-else class="badge badge-light badge-pill mr-1">0</span>
                {{ title }}
            </h5>
            <div class="header-elements">
                <button type="button" @click="() => { visible = !visible; visible_manually = true; }" class="btn btn-secondary-100 text-secondary btn-icon">
                    <span v-if="visible"><i class="icon-arrow-down5"></i></span>
                    <span v-else><i class="icon-arrow-up5"></i></span>
                </button>
            </div>
        </div>
        <b-collapse :id="'todo-collapse-' + type" v-model="visible" class="mt-2">
            <div v-if="error" class="card-body">
                <div class="alert alert-danger mb-0">{{ error }}</div>
            </div>
            <div v-else>
                <rednax-datatable
                    :columns="tableColumns"
                    :data="todos"
                    @rowclick="rowClick"
                    no-wrapper
                >
                    <template #cell_CardNo="{ row }">
                        <router-link :to="getUrl(row)">{{ row.CardNo }}</router-link>
                    </template>
                    <template #cell_Status="{ row }">
                        <div class="badge" :class="[ 'badge-' + row.StatusClass ]">{{ row.StatusName }}</div>
                    </template>
                    <template #cell_IsDeliverable="{ row }">
                        <div v-if="row.IsDeliverable" class="badge badge-success">Levererbar</div>
                        <div v-else class="badge badge-danger">Ej levererbar</div>
                    </template>
                    <template #cell_CalcShippingDate="{ row }">
                        <div v-if="row.DeliveryASAP" class="badge badge-teal">SKICKAS SNARAST</div>
                        <div v-else>{{ row.CalcShippingDate }}</div>
                    </template>
                    <template #cell_card_order="{ row }">
                        <router-link :to="getCardOrderUrl(row)">{{ row.OrderID }}</router-link>
                    </template>
                    <template #cell_WantedDeliveryDate="{ row }">
                        {{ row.WantedDeliveryDate }}
                        <div v-if="row.DeliveryASAP" class="badge badge-teal ml-1">ASAP</div>
                    </template>
                    <template #cell_ProdNames="{ row }">
                        <span v-if="row.ProdIDs && row.ProdNames">{{ row.ProdIDs.split(",").map((num, i) => `${num.trim()} - ${row.ProdNames.split("!")[i].trim()}`).join(", ") }}</span>
                    </template>
                </rednax-datatable>
            </div>
        </b-collapse>
    </div>
</template>
<script>
import apiClient from '@services/ApiClient';
import RednaxDatatable from '@components/Datatable/RednaxDatatableComponent.vue';
import { formatDateTime } from '@services/Helpers';

export default {
    name: 'TodoTable',
    components: {
        RednaxDatatable,
    },
    props: {
        type: {
            type: String,
            required: true,
        },
        deliveryGroup: {
            type: String,
            required: true,
        },
        title: {
            type: String,
        },
    },
    data() {
        return {
            loading: true,
            visible: false,
            visible_manually: false,
            todos: [],
            error: '',
            tableColumns: [
                {
                    data: 'CardNo',
                    header: 'Kortnummer',
                    class: 'w-150px',
                },
                {
                    data: 'Status',
                    header: 'Status',
                    class: 'w-150px',
                },
                {
                    data: 'IsDeliverable',
                    header: 'Lager',
                    class: 'w-100px',
                },
                {
                    data: 'Name',
                    header: 'Namn',
                    class: 'w-180px',
                },
                {
                    data: 'Street',
                    header: 'Adress',
                    sortable: false,
                    render(row) {
                        const arr = [row.Street, row.Zip, row.City, row.CountryCode];
                        return arr.filter((item) => !!(item)).join(', ');
                    },
                },
                {
                    data: 'ProdNames',
                    header: 'Produkt',
                    sortable: true,
                },
                {
                    data: 'OrderTS',
                    header: 'Orderdatum',
                    sortable: true,
                    class: 'w-150px',
                    render(row) {
                        return formatDateTime(row.OrderTS).substring(0, 10);
                    },
                },
                {
                    data: 'WantedDeliveryDate',
                    header: 'Önskat datum',
                    sortable: true,
                    class: 'w-150px',
                },
                // {
                //     data: 'CalcShippingDate',
                //     header: 'Beräknat datum',
                //     sortable: true,
                //     class: 'w-150px',
                // },
                {
                    data: 'card_order',
                    header: 'Order',
                    sortable: false,
                    class: 'w-100px',
                },
            ],
        };
    },
    mounted() {
        this.getData();
    },
    watch: {
        deliveryGroup() {
            this.todos = [];
            this.getData();
        },
        loading(val) {
            this.$emit('loaded', { loaded: !val, num_todos: this.todos.length, error: this.error });
        },
    },
    methods: {
        getUrl(row) {
            return `/prodorders/${row.ProdOrderID}`;
        },
        getCardOrderUrl(row) {
            return `/cardorders/${row.OrderID}`;
        },
        rowClick(row) {
            this.$router.push(this.getUrl(row));
        },
        extractHexColor(str) {
            return str.match(/#[A-Fa-f0-9]*/g)[0];
        },
        itemTooltipText(item) {
            return item.order_items.map((itm) => `${itm.prod_name} x${itm.quantity}`).join(' <br>');
        },
        getData() {
            this.loading = true;
            apiClient.get('/vue/prodorders/todo', {
                params: {
                    type: this.type,
                    delivery_group: this.deliveryGroup,
                },
            }).then((response) => {
                this.error = '';
                this.todos = response.data.data;
                if (this.visible_manually === false) {
                    if (response.data.data.length > 0) {
                        this.visible = true;
                    } else {
                        this.visible = false;
                    }
                }
            }).catch((error) => {
                this.todos = [];
                if (error.response && error.response.message) {
                    this.error = error.response.message;
                } else {
                    this.error = 'Något gick fel när data skulle hämtas...';
                }
            }).finally(() => {
                this.loading = false;
            });
        },
    },
    computed: {
        old_system_url() {
            return window.config.app.old_system_url;
        },
    },
};
</script>
<style>
.w-100px {
    width: 100px;
}
.w-150px {
    width: 150px;
}
.w-180px {
    width: 180px;
}
</style>
